import React from 'react';

const Replenishment = () => {
	return (
		<div>
			<h1> Replenishment</h1>
		</div>
	);
};

export default Replenishment;
